import { render, staticRenderFns } from "./relatePanel.vue?vue&type=template&id=4c91826f&scoped=true&"
import script from "./relatePanel.vue?vue&type=script&lang=js&"
export * from "./relatePanel.vue?vue&type=script&lang=js&"
import style0 from "./relatePanel.vue?vue&type=style&index=0&id=4c91826f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c91826f",
  null
  
)

component.options.__file = "relatePanel.vue"
export default component.exports